// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1__e92be74cf203c519cc7d","cls2":"CoreXNav-cls2___9e3dc5b1980fa709e9b CoreXNav-cls1__e92be74cf203c519cc7d"};